<div class="form-group">
    <textarea class="form-control" [ngModel]="respuesta?.alternativa" [disabled]="true"></textarea>
</div>
